<template>
  <footer class="footer">
    <div class="container">
      <div class="termsofuse" v-if="this.$store.state.termsAndConditions.documentUrl != null">
        <a
          style="cursor: pointer"
          class="footer-link"
          target="_blank"
          :style="'color:' + this.$store.state.termsAndConditions.documentUrlColor"
          :href="this.$store.state.termsAndConditions.documentUrl"
        >Conditions of use</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.footer {
  border-top: none !important;
  color: white;
  padding: 0;
}

.termsofuse {
  position: absolute;
  bottom: 5px;
  left: 30px;
}

.termsofuse a {
  color: white;
  font-size: 14px;
}

.termsofuse a:hover {
  color: white !important;
}

.feedback {
  position: absolute;
  bottom: 15px;
  right: 0;
  color: #888;
  background-color: #aaa;
  border: 1px #333 solid;
  padding: 10px;
}
</style>

